import { app } from '../core/App';
import { Player } from '../Player';
import ChunkBase from './ChunkBase';
import { BodyTypes } from './LevelManager';
import { RunManager } from './RunManager';

export class TrapAnimated extends window.SpinePlugin.SpineGameObject {
  public zIndex: number;

  protected isInitialised: boolean;
  protected chunk: ChunkBase | undefined;
  protected hasCollided: boolean;

  constructor(scene: Phaser.Scene, x: number, y: number, key?: string, animationName?: string, loop?: boolean) {
    super(scene, scene.sys.spine, x, y, key, animationName, loop);

    this.isInitialised = false;
    this.zIndex = 0;
    this.hasCollided = false;
  }

  public init() {
    if (!this.isInitialised) {
      this.injectMatter(this as unknown as Phaser.GameObjects.GameObject);
      this.isInitialised = true;
    }
  }

  public bindChunk(chunk: ChunkBase) {
    this.chunk = chunk;
  }

  public reset() {
    this.setAlpha(1);
    this.setScale(1);
    this.setVisible(true);
    this.setActive(true);
  }

  public recycle(removeFromChunk: boolean = false) {
    this.scene.tweens.killTweensOf(this);
    this.setVisible(false);
    this.setActive(false);
    this.setPosition(-1000, 0);

    if (removeFromChunk) this.chunk?.removeTrap(this);
    this.chunk = undefined;
  }

  protected injectMatter(target: Phaser.GameObjects.GameObject, rect?: MatterJS.Body) {
    let x = this.x;
    let y = this.y;

    if (rect) {
      let matterSprite = this.scene.matter.add.gameObject(target, rect) as Phaser.Physics.Matter.Sprite;
    } else {
      let matterSprite = this.scene.matter.add.gameObject(target, {
        label: BodyTypes.TouchTrap,
        isStatic: true
      }) as Phaser.Physics.Matter.Sprite;
    }

    this.scene.matter.body.setPosition(target.body as MatterJS.BodyType, this.scene.matter.vector.create(x, y));
    this.scene.matter.setVelocity(target.body as MatterJS.BodyType, 0, 0);
  }

  protected onCollision(pair: MatterJS.IPair) {
    if (this.hasCollided) return;

    if ((pair.bodyA as MatterJS.BodyType).label == BodyTypes.Player && (pair.bodyA as MatterJS.BodyType).gameObject instanceof Player) {
      this.onCollisionWithPlayer(pair.bodyA as MatterJS.BodyType, (pair.bodyA as MatterJS.BodyType).gameObject);
    } else if ((pair.bodyB as MatterJS.BodyType).label == BodyTypes.Player && (pair.bodyB as MatterJS.BodyType).gameObject instanceof Player) {
      this.onCollisionWithPlayer(pair.bodyB as MatterJS.BodyType, (pair.bodyB as MatterJS.BodyType).gameObject);
    }
  }

  protected onCollisionWithPlayer(body: MatterJS.BodyType, player: Player) {
    this.hasCollided = true;

    // Player dies on trap.
    console.log('Trap killing player!', player.CurrentCharacter);
    app.audioHandler.playSound(this.scene, 'SndDieBump', 'sfx');
    this.scene.events.emit(RunManager.events.PlayerDeath);
  }
}
